import { useMethods } from '@shared/hooks/methods'
import { useRestMutation } from './mutate'
import { useForm } from 'react-hook-form'

import { yupResolver } from '@hookform/resolvers/yup'
import mapServerErrors from '@shared/utils/mapErrors'

export function useRestForm({
    schema,
    defaultValues,
    invalidate=[],

    process,
    onBegin: formOnBegin,
    onFinish: formOnFinish,
    onRaise: formOnRaise
}) {
    const form = useForm({
        resolver: yupResolver(schema),
        defaultValues,
    })

    // Submission
    const { showMessage } = useMethods()

    const beginDefault = () => showMessage({
        text: 'جارٍ الحفظ...',
        loading: true
    })
    const finishDefault = () => showMessage({ text: 'تم الحفظ' })
    const raiseDefault = (e) => {
        mapServerErrors(e, form.setError, showMessage, form.getValues)
    }

    const {
        mutate,
        isPending
    } = useRestMutation({
        process,
        invalidate,
        onBegin: (sup, ...reactQueryProps) => {
            if (!!formOnBegin) formOnBegin(beginDefault, ...reactQueryProps)
            else beginDefault()
        },
        onFinish: (sup, ...reactQueryProps) => {
            if (!!formOnFinish) formOnFinish(finishDefault, ...reactQueryProps)
            else finishDefault()
        },
        onRaise: (sup, ...reactQueryProps) => {
            if (!!formOnRaise) formOnRaise(raiseDefault, ...reactQueryProps)
            else raiseDefault(...reactQueryProps)
        },
    })

    return {
        form,
        mutate,
        isPending
    }
}